// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class CalibrationService {

  constructor(
    private http: Http
  ) { }

  download(params: any[]): Observable<any> {
    if (!params) {
      return;
    }

    let calibrations = JSON.stringify(params);
    return this.http
      .get('calibrations/download?calibrations=' + calibrations, { responseType: ResponseContentType.Blob })
      .map(res => res.blob())
      .catch(err => Observable.throw(new Error(err)));
  }

  get(identifier?: string, search?: string, orderBy?: string, sortOrder?: string, pageSize?: number, currentPage?: number, filters?: string, fields?: string): Observable<Response> {
    currentPage = currentPage || 1;

    return this.http
      .get('calibrations/' + (filters && filters.includes('"IsAssay_=1"') ? '' : 'all/') + (identifier ? identifier : '') + '?fields=[' + (fields ? fields : '') + ']' + (search ? '&search=' + search : '') + (orderBy ? '&orderBy=["' + orderBy + (sortOrder ? ' ' + sortOrder : '') + '"]' : '') + (pageSize ? '&pageSize=' + pageSize + '&currentPage=' + currentPage : '') + (filters ? '&filters=[' + filters + ']' : ''))
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  getSituationDescription(status: number) {
    switch (status) {
      case 0: return 'Translate.None';
      case 1: return 'Translate.Approved';
      case 2: return 'Translate.Disapproved';
      case 3: return 'Translate.ApprovedWithReservation';
    }
  }

  getSituationIcon(status: number) {
    switch (status) {
      case 0: return '';
      case 1: return 'thumb_up';
      case 2: return 'thumb_down';
      case 3: return 'playlist_add_check';
    }
  }

  getStatusDescription(status: number) {
    switch (status) {
      case 0: return 'Translate.WaitingValidation';
      case 1: return 'Translate.Approved';
      case 2: return 'Translate.Disapproved';
      case 3: return 'Translate.InProgress';
      case 5: return 'Translate.CalculateResults';
    }
  }

  getStatusIcon(status: number) {
    switch (status) {
      case 0: return '';
      case 1: return 'done';
      case 2: return 'clear';
      case 3: return 'timelapse';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/calibrations/shared/calibration.service.ts